import { FormikProps } from "formik";
import Flex from "@/components/Flex";
import StyledButtonV2 from "@/components/app/StyledButtonV2";
import EncounterSign from "@/pages/app/provider/scheduling/appointment/encounter/EncounterSign";
import { Form2Payload } from "@/pages/app/provider/scheduling/appointment/encounter/encounter-constant";
import { EncounterSumaryFormTypeEnum } from "@/services";
import { useNavigate, useParams } from "react-router-dom";
import { INITIAL_F2F_FORM_TYPES } from "../../note-forms/initial-f2f";
import { usePendingSectionSaves } from "../../note-forms/readmission-f2f";
import { SIGN_VALIDATION_MESSAGES } from "../../encounter-constant";
import RequiredSectionsSign from "./RequiredSectionsSign";

const SIGN_LABEL = "Save & Sign Notes";

interface FormActionsProps {
  formik: FormikProps<Form2Payload>;
  /** The note type on screen; formik.values.formType stays at its default until the note is first saved. */
  formType: EncounterSumaryFormTypeEnum;
  prefillEncounterSummery: any;
  navigateWithoutGuard: (callback: () => void) => void;
}

const FormActions = ({
  formik,
  formType,
  prefillEncounterSummery,
  navigateWithoutGuard,
}: FormActionsProps) => {
  const { patientId } = useParams();
  const navigate = useNavigate();
  const { chiefComplaint, assessmentCodes } = formik.values;
  const isPremierNote = INITIAL_F2F_FORM_TYPES.includes(formType);
  const { flushAll } = usePendingSectionSaves();
  // Sections with their own API are saved first, so nothing typed in them is lost with the note.
  const saveNote = () => flushAll().then(() => formik.submitForm());
  const signValidationMessage = !chiefComplaint?.trim()
    ? SIGN_VALIDATION_MESSAGES.missingChiefComplaint
    : assessmentCodes?.length
      ? undefined
      : SIGN_VALIDATION_MESSAGES.missingIcdCode;

  return (
    <Flex
      justifyContent="flex-end"
      alignItems="center"
      gap={1.5}
      p={1}
      sx={{
        backgroundColor: "#FFFFFF",
        borderTop: "1px solid #E7E7E7",
        boxShadow: "0px -1px 8px 0px rgba(0, 0, 0, 0.08)",
      }}
    >
      <StyledButtonV2
        variant="outlined"
        size="small"
        label="Save & Close"
        onClick={() => {
          saveNote().then(() => {
            // Use navigateWithoutGuard for intentional Save & Close action
            navigateWithoutGuard(() => {
              navigate(`/app/provider/patients/new-patient/${patientId}/index`);
            });
          });
        }}
        sx={{ px: 1.75, py: 1 }}
      />
      {isPremierNote ? (
        <RequiredSectionsSign
          formik={formik}
          formType={formType}
          prefillEncounterSummery={prefillEncounterSummery}
          label={SIGN_LABEL}
          navigateWithoutGuard={navigateWithoutGuard}
        />
      ) : (
        <EncounterSign
          prefillSummeryData={prefillEncounterSummery}
          label={SIGN_LABEL}
          onSave={saveNote}
          navigateWithoutGuard={navigateWithoutGuard}
          signValidationMessage={signValidationMessage}
        />
      )}
    </Flex>
  );
};

export default FormActions;
